import React from 'react'

import { Box } from '@mui/material'

type HighlightProps = {
  children?: React.ReactNode
  active?: boolean
  color?: 'green' | 'red'
  className?: string
}

const Highlight = ({ children, active, color = 'green', className }: HighlightProps) =>
  active ? (
    <Box className={className} component="span" sx={{ color: color === 'red' ? 'error.main' : 'success.main' }}>
      {children}
    </Box>
  ) : (
    <>{children}</>
  )

export default Highlight
